import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { Auth } from '@core/services';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(Auth);

  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 || error.status === 403) {
          authService.logout();
        }
      }
      return throwError(() => error);
    })
  );
};
